<template>
  <avl-layout>
    <router-view />
  </avl-layout>
</template>

<script>
  import Layout from './views/layout';

  export default {
    components: {
      'avl-layout': Layout,
    },
    mounted() {
      window.addEventListener(
        'scroll',
        () => {
          this.$store.commit('utils/setScrolledFromTop', window.scrollY);
        },
        { passive: true },
      );
    },
  };
</script>

<style lang="scss">
  @import 'styles/styles';
</style>
